import { dynamicLoader } from '~/utils';

export const CompanyAddressGrid = dynamicLoader({
  name: 'CompanyAddressGrid',
  importFunc: () => import('./company-address-grid'),
});